import { useRef, useState } from 'react';
import 'styles/affiliate-id-card.scss';

const selectText = (element: HTMLElement) => {
  const range = document.createRange();
  range.selectNodeContents(element);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
};

export const AffiliateIdCard: React.FC<{ affiliateId: string; email?: string }> = ({ affiliateId, email }): JSX.Element => {
  const [copied, setCopied] = useState(false);
  const idElement = useRef<HTMLElement>(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(affiliateId);
      setCopied(true);
    } catch {
      if (idElement.current) selectText(idElement.current);
    }
  };

  return (
    <div className="rewamp-form affiliate-id-card">
      <h2>Your Affiliate ID</h2>
      <div className="affiliate-id">
        <code ref={idElement}>{affiliateId}</code>
        <button type="button" onClick={copy}>{copied ? 'Copied' : 'Copy'}</button>
      </div>
      {email && <p>We also sent it to {email}.</p>}
      <ol>
        <li>In your WHMCS admin, click the <strong>Configuration</strong> icon and open <strong>System Settings &gt; Apps &amp; Integrations &gt; Addon Modules</strong>.</li>
        <li>Find <strong>SAW.com Domain Acquisition</strong> and click <strong>Configure</strong>.</li>
        <li>Paste the ID into <strong>Affiliate ID</strong> and save.</li>
      </ol>
    </div>
  );
};

export default AffiliateIdCard;
